import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { Location } from "history";
import ControlsArea from "layout/common/controls-area/controls-area/";
import StageArea from "layout/common/stage-area/stage-area";
import UserArea from "layout/common/user-area";
import LoginBox from "layout/common/login-box";
import LocalStorageHandler from "./common/local-storage-handler/";
import UserNavigation from "./common/user-navigation/";
import { CalendarSteps } from "ui/constants";
import OwnerPageImageCropper from "./common/controls-area/image-cropper/owner-page-image-cropper";
import CoverImageCropper from "./common/controls-area/image-cropper/cover-image-cropper";

const isCalendarView = (location: Location<any>) => {
    if (
        location.pathname.endsWith(CalendarSteps.cover) ||
        location.pathname.endsWith(CalendarSteps.ownerPage) ||
        location.pathname.endsWith(CalendarSteps.insert) ||
        location.pathname.endsWith(CalendarSteps.extraPages) ||
        location.pathname.endsWith(CalendarSteps.monthDivider) ||
        location.pathname.endsWith(CalendarSteps.summary)
    ) {
        return true;
    }
    return false;
};

const isOwnerPage = (location: Location<any>) => {
    if (location.pathname.endsWith(CalendarSteps.ownerPage)) {
        return true;
    }

    return false;
};

const MainLayout: React.FC<RouteComponentProps> = ({ children, location }) => {
    return (
        <>
            {isCalendarView(location) ? (
                location.pathname.endsWith(CalendarSteps.summary) ? (
                    <>
                        <ControlsArea />
                        <LocalStorageHandler>
                            <StageArea>{children}</StageArea>
                        </LocalStorageHandler>
                        {/* np */}
                    </>
                ) : (
                    <>
                        <ControlsArea />
                        <LocalStorageHandler>
                            <StageArea>
                                {isOwnerPage(location) ? (
                                    <OwnerPageImageCropper />
                                ) : (
                                    <CoverImageCropper />
                                )}
                                <UserArea />
                                <UserNavigation />
                                {children}
                            </StageArea>
                        </LocalStorageHandler>
                        <LoginBox />
                    </>
                )
            ) : (
                children
            )}
        </>
    );
};

export default withRouter(MainLayout);
